<template>
  <div>
    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card height="190" class="text-center">
        <v-progress-circular
          :indeterminate="loading"
          :size="100"
          color="primary"
          class="mt-4 "
        >Loading...
        </v-progress-circular>
        <v-card-actions>
          <v-btn class="ml-auto my-2" color="primary" @click="loading=false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar color="success" v-model="snackbarSuccess">
      <v-list-item-title>
        <v-icon class="mr-2">mdi-check-circle-outline</v-icon>
        {{ snackbarSuccessText }}
      </v-list-item-title>
    </v-snackbar>

    <v-container class="my-0 py-0">
      <v-radio-group v-model="mode" row class="ma-0 pa-0">
        <v-radio label="手動" value="1"></v-radio>
        <v-radio label="自動" value="2"></v-radio>
      </v-radio-group>      
      <v-row>
        <v-col cols="12">
          <v-btn
            variant="outlined"
            class="mr-4 mb-4"
            @click="clear"
          >クリア</v-btn>
          <div style="display: inline-block; vertical-align: middle;" class="mr-3 mb-3">月12</div>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="movie"
          >映画</v-btn>
          <div style="display: inline-block; vertical-align: middle;" class="mr-3 mb-3">水3</div>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="single"
          >シングル</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="album"
          >アルバム</v-btn>
          <div style="display: inline-block; vertical-align: middle;" class="mr-3 mb-3">木11</div>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="dvd"
          >DVD</v-btn>
          <div style="display: inline-block; vertical-align: middle;" class="mr-3 mb-3">木12</div>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="viewership_rating"
          >視聴率</v-btn>
          <div style="display: inline-block; vertical-align: middle;" class="mr-3 mb-3">金12</div>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="game"
          >ゲーム</v-btn>
          <div style="display: inline-block; vertical-align: middle;" class="mr-3 mb-3">土日</div>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="baseball"
          >野球</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="senbatsu"
          >高校野球</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="mlb"
          >MLB</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="mlb2"
          >MLB2</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="softball"
          >女子ソフト</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="soccer"
          >Jリーグ</v-btn>
          <v-btn
            variant="outlined"
            :color="mode === '1' ? 'secondary' : 'error'"
            class="mr-4 mb-4"
            @click="() => mode === '1' ? world_soccer() : ai_world_soccer()"
          >海外サッカー</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="female_soccer"
          >女子サッカー</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="horseracing"
          >競馬</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="sumou"
          >大相撲</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="figure"
          >フィギュア</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="fighting"
          >格闘技</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="golf"
          >ゴルフ</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="tennis"
          >テニス</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="table_tennis"
          >卓球</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="world_table_tennis"
          >世界卓球</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="f1"
          >F1</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="() => mode === '1' ? volleyball() : aiVolleyball()"
          >バレー</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="rugby"
          >ラグビー</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="basketball"
          >バスケ</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="ski_men"
          >Ski男子</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="ski_women"
          >Ski女子</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="election"
          >選挙</v-btn>
          <!-- <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="n225"
          >日経平均</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="exchange"
          >為替</v-btn> -->
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="economics"
          >経済指標</v-btn>
          <!-- <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="fortune"
          >占い</v-btn> -->
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="mahjong"
          >麻雀</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="shogi"
          >将棋</v-btn>
          <v-btn
            variant="outlined"
            color="secondary"
            class="mr-4 mb-4"
            @click="olympic"
          >五輪</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-form v-for="(prediction, index) in predictions" :key="index">
      <v-container class="my-0 py-0">
        <v-row>
          <v-col cols="4">
            <v-select
              v-model="prediction.categoryId"
              item-text="label"
              item-value="value"
              :items="categoryList"
              label="カテゴリー"
            />
            <v-text-field
              v-model="prediction.predictionTitle"
              label="タイトル"
            />
            <v-file-input v-model="prediction.imageFile" label="画像を選択" @change="(file) => imageChanged(file, index)"></v-file-input>
            <v-textarea
              v-model="prediction.predictionBody"
              label="本文"
            ></v-textarea>
            <v-text-field
              v-model="prediction.link1"
              label="リンク１"
            />
            <v-text-field
              v-model="prediction.link2"
              label="リンク２"
            />
            <v-text-field
              v-model="prediction.link3"
              label="リンク３"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="prediction.choices[0]"
              label="選択肢１"
            />
            <v-text-field
              v-model="prediction.choices[1]"
              label="選択肢２"
            />
            <v-text-field
              v-model="prediction.choices[2]"
              label="選択肢３"
            />
            <v-text-field
              v-model="prediction.choices[3]"
              label="選択肢４"
            />
            <v-text-field
              v-model="prediction.choices[4]"
              label="選択肢５"
            />
            <v-row>
              <v-col cols="6">
                <v-dialog
                  v-model="prediction.closeDateDialog"
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="prediction.closeDate"
                      label="締切日"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="prediction.closeDate" @input="prediction.closeDateDialog = false; prediction.closeTimeDialog = true"></v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="6">
                <v-dialog
                  v-model="prediction.closeTimeDialog"
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="prediction.closeTime"
                      label="締切時刻"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker 
                    v-model="prediction.closeTime" 
                    format="24hr"
                    active-picker="HOUR"
                    :allowed-minutes="allowedMinutes"
                    @click:hour="(hour) => setOpenMinute(hour, index)"
                  ></v-time-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-select
              v-model="prediction.openPeriod"
              item-text="label"
              item-value="value"
              :items="openPeriodList"
              label="開催期間"
            />
            <v-select
              v-model="prediction.finalizeAfter"
              item-text="label"
              item-value="value"
              :items="finalizeAfterList"
              label="結果確定時間"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="prediction.choices[5]"
              label="選択肢６"
            />
            <v-text-field
              v-model="prediction.choices[6]"
              label="選択肢７"
            />
            <v-text-field
              v-model="prediction.choices[7]"
              label="選択肢８"
            />
            <v-text-field
              v-model="prediction.choices[8]"
              label="選択肢９"
            />
            <v-text-field
              v-model="prediction.choices[9]"
              label="選択肢１０"
            />
            <!-- <v-select
              v-model="prediction.creatorReward"
              item-text="label"
              item-value="value"
              :items="creatorRewardList"
              label="出題者報酬率"
            />
            <v-select
              v-model="prediction.correctReporterReward"
              item-text="label"
              item-value="value"
              :items="correctReporterRewardList"
              label="確定者報酬率"
            /> -->
            <p class="text-right">
              <v-btn
                color="primary"
                @click="submit(index)"
              >作成</v-btn>
            </p>
            <v-img :src="prediction.imageUrl"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  import axios from "axios"
  import moment from 'moment'
  import mixin from '@/util/mixin'

  export default {
    mixins: [mixin],
    data () {
      return {
        predictionTemplate: {
          categoryId: undefined,
          predictionTitle: undefined,
          imageFile: undefined,
          predictionBody: undefined,
          link1: undefined,
          link2: undefined,
          link3: undefined,
          choices: [
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
          ],
          closeDate: undefined,
          closeDateDialog: false,
          closeTime: undefined,
          closeTimeDialog: false,
          openPeriod: 1,
          finalizeAfter: 24,
          creatorReward: 0.0,
          correctReporterReward: 25,
          imageUrl: '',
        },
        predictions: [],
        mode: '1',
        snackbarSuccess: false,
        snackbarSuccessText: '',
        categoryList: [
        {
            label: '野球',
            value: '20',
          },
          {
            label: 'サッカー',
            value: '30',
          },
          {
            label: 'その他スポーツ',
            value: '40',
          },
          // {
          //   label: 'ゲーム',
          //   value: '45',
          // },
          {
            label: 'エンタメ',
            value: '50',
          },
          {
            label: '政治・経済',
            value: '60',
          },
          // {
          //   label: 'その他',
          //   value: '70',
          // },
        ],
        allowedMinutes: [0],
        openPeriodList: [...Array(7)].map((_, i) => ({label: `${i + 1}日間`, value: i + 1})),
        finalizeAfterList: [...Array(24)].map((_, i) => ({label: `${i + 1}時間後`, value: i + 1})),
        creatorRewardList: [...Array(20)].map((_, i) => ({label: `${i * 0.5}%`, value: i * 0.5})),
        correctReporterRewardList: [...Array(25)].map((_, i) => ({label: `${i + 1}%`, value: i + 1})),
        loading: false,
      }
    },
    methods: {
      setOpenMinute (hour, index) {
        this.predictions[index].closeTime = hour < 10 ? `0${hour}:00` : `${hour}:00`
        this.predictions[index].closeTimeDialog = false
        if (['single', 'album'].includes(this.predictions[index].imageFile.name)) {
          const dateStr = moment(this.predictions[index].closeDate).add(5, 'days').format('M月D日')
          this.predictions[index].predictionBody = this.predictions[index].predictionBody.replace('${M月D日}', dateStr)
          const releaseDate = moment(this.predictions[index].closeDate).add(-7, 'days').format('M月D日(ddd)')
          this.predictions[index].predictionBody = this.predictions[index].predictionBody.replace('${M月D日(ddd)}', releaseDate)
        } else if (['dvd'].includes(this.predictions[index].imageFile.name)) {
          const dateStr = moment(this.predictions[index].closeDate).add(4, 'days').format('M月D日')
          this.predictions[index].predictionBody = this.predictions[index].predictionBody.replace('${M月D日}', dateStr)
          const releaseDate = moment(this.predictions[index].closeDate).add(-8, 'days').format('M月D日(ddd)')
          this.predictions[index].predictionBody = this.predictions[index].predictionBody.replace('${M月D日(ddd)}', releaseDate)
        } else if (['game'].includes(this.predictions[index].imageFile.name)) {
          const dateStr = moment(this.predictions[index].closeDate).add(3, 'days').format('M月D日(ddd)')
          const from = moment(this.predictions[index].closeDate).add(-11, 'days').format('YYYY年M月D日')
          const to = moment(this.predictions[index].closeDate).add(-5, 'days').format('YYYY年M月D日')
          this.predictions[index].predictionBody = this.predictions[index].predictionBody.replace('${M月D日(ddd)}', dateStr).replace('${YYYY年M月D日～YYYY年M月D日}', `${from}～${to}`)
        } else if (['movie'].includes(this.predictions[index].imageFile.name)) {
          const dateStr = moment(this.predictions[index].closeDate).add(1, 'days').format('M月D日(ddd)')
          this.predictions[index].predictionTitle = this.predictions[index].predictionTitle.replace('${M月D日(ddd)}', dateStr)
          this.predictions[index].predictionBody = this.predictions[index].predictionBody.replace('${M月D日(ddd)}', dateStr)
        } else if (['viewership_rating'].includes(this.predictions[index].imageFile.name)) {
          const dateStr = moment(this.predictions[index].closeDate).add(-4, 'days').format('M月D日(ddd)')
          this.predictions[index].predictionTitle = this.predictions[index].predictionTitle.replace('${M月D日(ddd)}', dateStr)
          this.predictions[index].predictionBody = this.predictions[index].predictionBody.replace('${M月D日(ddd)}', dateStr)
        } else {
          const dateStr = moment(this.predictions[index].closeDate).format('M月D日(ddd)')
          this.predictions[index].predictionTitle = this.predictions[index].predictionTitle.replace('${M月D日(ddd) H}', `${dateStr} ${hour}`).replace('${M月D日(ddd)}', dateStr)
          this.predictions[index].predictionBody = this.predictions[index].predictionBody.replace('${M月D日(ddd) H}', `${dateStr} ${hour}`).replace('${M月D日(ddd)}', dateStr)
        }
      },
      clear () {
        this.predictions.splice(0, this.predictions.length)
        this.predictions.push({...this.predictionTemplate})
      },
      single () {
        this.predictions[0].categoryId = '50'
        this.predictions[0].predictionTitle = '〇〇の「」の初登場順位は？'
        this.predictions[0].imageFile = {name: 'single'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd)}発売の〇〇の最新シングル「」は${M月D日}付の週間シングルランキングで初登場何位になるでしょうか？'
        this.predictions[0].link1 = 'https://www.oricon.co.jp/rank/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '1位',
          '2位',
          '3位',
          '4位',
          '5位',
          '6位',
          '7位',
          '8位',
          '9位',
          '10位以下',
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      album () {
        this.predictions[0].categoryId = '50'
        this.predictions[0].predictionTitle = '〇〇の「」の初登場順位は？'
        this.predictions[0].imageFile = {name: 'album'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd)}発売の〇〇の最新アルバム「」は${M月D日}付の週間アルバムランキングで初登場何位になるでしょうか？'
        this.predictions[0].link1 = 'https://www.oricon.co.jp/rank/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '1位',
          '2位',
          '3位',
          '4位',
          '5位',
          '6位',
          '7位',
          '8位',
          '9位',
          '10位以下',
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      dvd () {
        this.predictions[0].categoryId = '50'
        this.predictions[0].predictionTitle = '〇〇の「」の初登場順位は？'
        this.predictions[0].imageFile = {name: 'dvd'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd)}発売の〇〇の最新DVD「」は${M月D日}付の週間DVDランキングで初登場何位になるでしょうか？'
        this.predictions[0].link1 = 'https://www.oricon.co.jp/rank/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '1位',
          '2位',
          '3位',
          '4位',
          '5位',
          '6位',
          '7位',
          '8位',
          '9位',
          '10位以下',
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      baseball () {
        this.predictions[0].categoryId = '20'
        this.predictions[0].predictionTitle = '${M月D日(ddd)}の〇〇対△△の試合結果は？'
        this.predictions[0].imageFile = {name: 'baseball'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から××で行われるプロ野球〇〇対△△の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://npb.jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇の勝ち',
          '△△の勝ち',
          '引き分け',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      softball () {
        this.predictions[0].categoryId = '20'
        this.predictions[0].predictionTitle = '${M月D日(ddd)}の〇〇vs△△の試合結果は？'
        this.predictions[0].imageFile = {name: 'softball'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から××で行われるニトリJD.LEAGUE 〇〇vs△△の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://jdleague.jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇の勝ち',
          '△△の勝ち',
          '引き分け',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      senbatsu () {
        this.predictions[0].categoryId = '20'
        this.predictions[0].predictionTitle = '【高校野球】〇〇vs△△の試合結果は？'
        this.predictions[0].imageFile = {name: 'senbatsu'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われる【高校野球】〇〇vs△△の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://baseball.yahoo.co.jp/hsb_summer/schedule/competition'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇の勝ち',
          '△△の勝ち',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      soccer () {
        this.predictions[0].categoryId = '30'
        this.predictions[0].predictionTitle = '【Jリーグ】〇〇vs△△の試合結果は？'
        this.predictions[0].imageFile = {name: 'soccer'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から××で行われる【Jリーグ】〇〇vs△△の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://www.jleague.jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇の勝ち',
          '△△の勝ち',
          '引き分け',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      world_soccer () {
        this.predictions[0].categoryId = '30'
        this.predictions[0].predictionTitle = '【☆☆】〇〇 vs △△の試合結果は？'
        this.predictions[0].imageFile = {name: 'world_soccer'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から××で行われる【☆☆】〇〇 vs △△の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://soccer.yahoo.co.jp/ws/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇の勝ち',
          '△△の勝ち',
          '引き分け',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      female_soccer () {
        this.predictions[0].categoryId = '30'
        this.predictions[0].predictionTitle = '【WEリーグ】〇〇vs△△の試合結果は？'
        this.predictions[0].imageFile = {name: 'female_soccer'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から××で行われる【WEリーグ】〇〇vs△△の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://weleague.jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇の勝ち',
          '△△の勝ち',
          '引き分け',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      tennis () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【△△】〇〇で優勝するのは？'
        this.predictions[0].imageFile = {name: 'tennis'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = 'M月d日～M月d日に☆☆で行われる【☆☆】〇〇で優勝するのはどの選手でしょうか？'
        this.predictions[0].link1 = 'https://sportsnavi.ht.kyodo-d.jp/tennis/schedule/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      fighting () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【】〇〇vs△△で勝利するのは？'
        this.predictions[0].imageFile = {name: 'fighting'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = ' ${M月D日(ddd)}に××で行われる【】〇〇vs△△で勝利するのはどちらの選手でしょうか？'
        this.predictions[0].link1 = 'https://sports.yahoo.co.jp/fight/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇が勝つ',
          '△△が勝つ',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      golf () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '〇〇で優勝するのは？'
        this.predictions[0].imageFile = {name: 'golf'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = 'M月d日～M月d日に☆☆で行われる〇〇で優勝するのはどの選手でしょうか？'
        this.predictions[0].link1 = 'https://sports.yahoo.co.jp/golf/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      rugby () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【リーグワン】〇〇vs△△の試合結果は？'
        this.predictions[0].imageFile = {name: 'rugby'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われる【リーグワン】〇〇vs△△の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://league-one.jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇の勝ち',
          '△△の勝ち',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      table_tennis () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【Tリーグ】〇〇vs△△の試合結果は？'
        this.predictions[0].imageFile = {name: 'table_tennis'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われる【Tリーグ】〇〇vs△△の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://tleague.jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇の勝ち',
          '△△の勝ち',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      world_table_tennis () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【世界卓球】決勝T２回戦の日本女子の試合結果は？'
        this.predictions[0].imageFile = {name: 'world_table_tennis'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われる【世界卓球】決勝T２回戦の日本女子の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://www.tv-tokyo.co.jp/wttc2024/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '日本の勝ち',
          '日本の負け',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 12
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      basketball () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【Bリーグ】〇〇vs△△の試合結果は？'
        this.predictions[0].imageFile = {name: 'basketball'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から××で行われる〇〇vs△△の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://www.bleague.jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇の勝ち',
          '△△の勝ち',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      volleyball () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【Vリーグ】〇〇vs△△の試合結果は？'
        this.predictions[0].imageFile = {name: 'volleyball'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われるVリーグ：〇〇vs△△の試合結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://www.vleague.jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇の勝ち',
          '△△の勝ち',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      f1 () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【F1バーレーンGP】予選での角田裕毅選手の順位は？'
        this.predictions[0].imageFile = {name: 'f1'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われるF1バーレーンGPの予選で角田裕毅選手は何位になるでしょうか？'
        this.predictions[0].link1 = 'https://sports.yahoo.co.jp/f1/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '1位～5位',
          '6位～10位',
          '11位～15位',
          '16位～20位',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      ski_men () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【FISスキージャンプ】W杯ラハティでの小林陵侑選手の順位は？'
        this.predictions[0].imageFile = {name: 'ski_men'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われる【FISスキージャンプ】W杯ラハティでの小林陵侑選手は何位になるでしょうか？'
        this.predictions[0].link1 = 'https://zutto-sports.com/fis-ski-jumping-world-cup-schedule-mens'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '1位',
          '2位',
          '3位',
          '4位',
          '5位',
          '6位',
          '7位',
          '8位',
          '9位',
          '10位以下',
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      ski_women () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【FISスキージャンプ】W杯ラハティでの伊藤有希選手の順位は？'
        this.predictions[0].imageFile = {name: 'ski_women'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われる【FISスキージャンプ】W杯ラハティでの伊藤有希選手は何位になるでしょうか？'
        this.predictions[0].link1 = 'https://zutto-sports.com/fis-ski-jumping-world-cup-schedule'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '1位',
          '2位',
          '3位',
          '4位',
          '5位',
          '6位',
          '7位',
          '8位',
          '9位',
          '10位以下',
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      figure () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【フィギュアスケート】2025-26_フランス大会での三原舞依選手の順位は？'
        this.predictions[0].imageFile = {name: 'figure'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われる【フィギュアスケート】2025-26_フランス大会での三原舞依選手は何位になるでしょうか？'
        this.predictions[0].link1 = 'https://sports.yahoo.co.jp/figureskate/schedule/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '1位',
          '2位',
          '3位',
          '4位',
          '5位',
          '6位',
          '7位',
          '8位',
          '9位',
          '10位以下',
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      horseracing () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【GI】〇〇で1着になる馬は？'
        this.predictions[0].imageFile = {name: 'horseracing'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:45に行われる〇〇で1着になる馬を予想してください。'
        this.predictions[0].link1 = 'https://www.jra.go.jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      game () {
        this.predictions[0].categoryId = '50'
        this.predictions[0].predictionTitle = '【☆☆】〇〇の販売本数ランキングは？'
        this.predictions[0].imageFile = {name: 'game'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd)}付けのファミ通.comのゲームソフト販売本数ランキング（集計期間：${YYYY年M月D日～YYYY年M月D日}）で【☆☆】〇〇は何位に入るでしょうか？'
        this.predictions[0].link1 = 'https://www.famitsu.com/ranking/game-sales/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '1位',
          '2位',
          '3位',
          '4位',
          '5位',
          '6位',
          '7位',
          '8位',
          '9位',
          '10位以下',
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      viewership_rating () {
        this.predictions[0].categoryId = '50'
        this.predictions[0].predictionTitle = '${M月D日(ddd)}放送の「〇〇」の個人視聴率は？'
        this.predictions[0].imageFile = {name: 'viewership_rating'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd)} 0:00から放送される「〇〇」の個人視聴率は前回の視聴率△△%からどう変わるでしょうか？'
        this.predictions[0].link1 = 'https://www.videor.co.jp/tvrating/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '±0.1%以内',
          '0.1%より上がる',
          '0.1%より下がる',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      movie () {
        this.predictions[0].categoryId = '50'
        this.predictions[0].predictionTitle = '${M月D日(ddd)}の「〇〇」の順位は？'
        this.predictions[0].imageFile = {name: 'movie'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd)}に発表される国内映画ランキングで「〇〇」の順位はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://eiga.com/ranking/jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '1位',
          '2位',
          '3位',
          '4位',
          '5位',
          '6位',
          '7位',
          '8位',
          '9位',
          '10位以下',
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      n225 () {
        this.predictions[0].categoryId = '60'
        this.predictions[0].predictionTitle = 'M月d日(E)の日経平均株価の終値は？'
        this.predictions[0].imageFile = {name: 'n225'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = 'M月d日(E)の日経平均株価の終値は前営業日の終値と比べてどうなっているでしょうか？'
        this.predictions[0].link1 = 'https://finance.yahoo.co.jp/quote/998407.O'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '±0.2以内',
          '0.2%より上がる',
          '0.2%より下がる',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      exchange () {
        this.predictions[0].categoryId = '60'
        this.predictions[0].predictionTitle = 'M月d日(E)のドル円は？'
        this.predictions[0].imageFile = {name: 'exchange'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = 'M月d日(E)のドル円は前営業日の終値と比べてどうなっているでしょうか？尚、結果はリンク先のチャートの日足の終値で判定するものとします。'
        this.predictions[0].link1 = 'https://finance.yahoo.co.jp/quote/USDJPY=X/chart'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '同じか上がっている',
          '下がっている',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      economics () {
        this.predictions[0].categoryId = '60'
        this.predictions[0].predictionTitle = '【米国】${M月D日(ddd)}発表の〇〇は？'
        this.predictions[0].imageFile = {name: 'economics'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00に発表される【米国】〇〇は予想の△△%からどう変わるでしょうか？'
        this.predictions[0].link1 = 'https://fx.minkabu.jp/indicators'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '予想通り',
          '予想より上がる',
          '予想より下がる',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      fortune () {
        this.predictions[0].categoryId = '50'
        this.predictions[0].predictionTitle = 'M月d日(E)の12星座占いで1位になるのは？'
        this.predictions[0].imageFile = {name: 'fortune'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = 'M月d日(E)の朝日新聞DIGITALの12星座占いで1位になるのはどの星座でしょうか？'
        this.predictions[0].link1 = 'https://www.asahi.com/uranai/12seiza/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          'おひつじ座、または、おうし座',
          'ふたご座、または、かに座',
          'しし座、または、おとめ座',
          'てんびん座、または、さそり座',
          'いて座、または、やぎ座',
          'みずがめ座、または、うお座',
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 9
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      mahjong () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【Mリーグ】${M月D日(ddd)}の対戦で1位になるのは？'
        this.predictions[0].imageFile = {name: 'mahjong'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd)}に行われるMリーグの対戦で1位になるのはどのチームでしょうか？'
        this.predictions[0].link1 = 'https://m-league.jp/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '赤坂ドリブンズ',
          'EX風林火山',
          'KADOKAWAサクラナイツ',
          'U-NEXT Pirates',
          'KONAMI麻雀格闘倶楽部',
          'TEAM RAIDEN / 雷電',
          'BEAST X',
          '渋谷ABEMAS',
          'セガサミーフェニックス',
          'EARTH JETS',
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      mlb () {
        this.predictions[0].categoryId = '20'
        this.predictions[0].predictionTitle = '【MLB】${M月D日(ddd)}の〇〇対△△の試合結果は？'
        this.predictions[0].imageFile = {name: 'mlb'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われるMLB〇〇対△△の試合結果はどちらが勝つでしょうか？'
        this.predictions[0].link1 = 'https://baseball.yahoo.co.jp/mlb/schedule/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇が勝つ',
          '△△が勝つ',
          '引き分け',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      mlb2 () {
        this.predictions[0].categoryId = '20'
        this.predictions[0].predictionTitle = '【MLB】${M月D日(ddd)}の☆☆投手の結果は？'
        this.predictions[0].imageFile = {name: 'mlb'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われるMLB〇〇対△△の試合に先発予定の☆☆投手の結果はどうなるでしょうか？'
        this.predictions[0].link1 = 'https://baseball.yahoo.co.jp/mlb/schedule/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '勝ち投手になる',
          '負け投手になる',
          '勝ち負け付かず',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      sumou () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【春場所】${M月D日(ddd)}の「霧島」対「阿炎」の勝者は？'
        this.predictions[0].imageFile = {name: 'sumou'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd)}に行われる春場所初日の取組、東大関「霧島」対東小結「阿炎」の勝者はどちらになるでしょうか？'
        this.predictions[0].link1 = 'https://sports.yahoo.co.jp/sumo/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '霧島が勝つ',
          '阿炎が勝つ',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      election () {
        this.predictions[0].categoryId = '60'
        this.predictions[0].predictionTitle = '【】${M月D日(ddd)}の〇〇で当選するのは？'
        this.predictions[0].imageFile = {name: 'election'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd)}に行われる【】〇〇で当選するのはどの候補者でしょうか？'
        this.predictions[0].link1 = 'https://go2senkyo.com/schedule'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      shogi () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【】〇〇vs△△で勝利するのは？'
        this.predictions[0].imageFile = {name: 'shogi'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd)}に行われる【】〇〇vs△△で勝利するのはどちらの棋士でしょうか？'
        this.predictions[0].link1 = 'https://www.shogi.or.jp/game/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇が勝つ',
          '△△が勝つ',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      olympic () {
        this.predictions[0].categoryId = '40'
        this.predictions[0].predictionTitle = '【】〇〇vs△△で勝利するのは？'
        this.predictions[0].imageFile = {name: 'olympic'}
        this.setImageUrl(this.predictions[0].imageFile.name, 0)
        this.predictions[0].predictionBody = '${M月D日(ddd) H}:00から行われる【】〇〇vs△△で勝利するのはどちらでしょうか？'
        this.predictions[0].link1 = 'https://sports.yahoo.co.jp/milanocortina2026/olympic/'
        this.predictions[0].link2 = undefined
        this.predictions[0].link3 = undefined
        this.predictions[0].choices = [
          '〇〇が勝つ',
          '△△が勝つ',
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        ]
        this.predictions[0].closeDate = undefined
        this.predictions[0].closeTime = undefined
        this.predictions[0].openPeriod = 1
        this.predictions[0].finalizeAfter = 24
        this.predictions[0].creatorReward = 0.0
        this.predictions[0].correctReporterReward = 0
      },
      submit (index) {
        const db = this.$fb.firestore
        const batch = this.$fb.writeBatch(db)
        const now = new Date()
        const predictionId = `A${now.getTime()}`
        const creatorId = 'iPCkxpyyA2Tytx2guNxev7yTd132'
        const hour = parseInt(this.predictions[index].closeTime.split(':')[0], 10)
        const closeAt = new Date(new Date(this.predictions[index].closeDate).setHours(hour, 0, 0, 0))
        const nextCheckAt = new Date(closeAt.getTime() + 4 * 60 * 60 * 1000)
        const openAt = new Date(new Date(closeAt.getTime()).setDate(closeAt.getDate() - this.predictions[index].openPeriod))
        const reportingTo = new Date(new Date(closeAt.getTime()).setHours(closeAt.getHours() + this.predictions[index].finalizeAfter, 0, 0, 0))

        const defaultImagePath = this.getDefaultImagePath(this.predictions[index].imageFile.name)
        const imagePath = !this.predictions[index].imageFile 
          ? ''
          : defaultImagePath
          ? defaultImagePath
          : `images/predictions/${creatorId}/${predictionId}.png`
        if (imagePath && this.predictions[index].imageFile.name.includes('.')) {
          const imageRef = this.$fb.ref(this.$fb.storage, imagePath)
          this.$fb.uploadBytesResumable(imageRef, this.predictions[index].imageFile)
        }

        const predictionRef = this.$fb.doc(this.$fb.firestore, 'prediction', predictionId)
        batch.set(predictionRef, {
          created_at: new Date(),
          updated_at: new Date(),
          creator_id: creatorId,
          category_id: this.predictions[index].categoryId,
          prediction_title: this.predictions[index].predictionTitle,
          image_path: imagePath,
          prediction_body: this.predictions[index].predictionBody,
          link1: this.predictions[index].link1 || '',
          link2: this.predictions[index].link2 || '',
          link3: this.predictions[index].link3 || '',
          open_at: openAt,
          close_at: closeAt,
          reporting_from: closeAt,
          reporting_to: reportingTo,
          index: this.bigram(this.predictions[index].predictionTitle),
          creator_reward_rate: this.predictions[index].creatorReward,
          reporter_reward_rate: this.predictions[index].correctReporterReward,
          is_published: false,
          answer_count: 0,
          comment_count: 0,
          is_finalized: false,
          is_invalid: false,
          is_second: false,
          next_check_at: nextCheckAt,
          check_count: 0,
        })
        let i = 1
        for (const choice of this.predictions[index].choices) {
          if (!choice) continue
          const choiceRef = this.$fb.doc(this.$fb.firestore, 'prediction', predictionId, 'choice', String(i))
          batch.set(choiceRef, {
            choice: choice,
            answer_count: 0,
            odds: 1.0,
            report_count: 0,
            second_report_count: 0,        
          })
          i++
        }
        batch.commit().then(() => {
          this.snackbarSuccessText = '予想問題を作成しました。'
          this.snackbarSuccess = true
          if (this.predictions.length === 1) {
            this.clear()
          } else {
            this.predictions.splice(index, 1)
          }
        })
      },
      imageChanged (file, index) {
        console.log(file)
        if (file !== undefined && file !== null) {
          if (file.name.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(file)
          fr.addEventListener('load', () => {
            this.predictions[index].imageUrl = fr.result
          })
        } else {
          this.predictions[index].imageUrl = ''
        }
      },
      getDefaultImagePath (imageFileName) {
        switch (imageFileName) {
          case 'single':
          case 'album':
          case 'dvd':
            return 'images/predictions/presets/A1707292760133.png'
          case 'baseball':
          case 'senbatsu':
            return 'images/predictions/presets/A1707311042912.png'
          case 'mlb':
            return 'images/predictions/presets/C17108748076400.png'
          case 'soccer':
            return 'images/predictions/presets/A1707384128200.png'
          case 'world_soccer':
            return 'images/predictions/presets/world_soccer.png'
            case 'female_soccer':
            return 'images/predictions/presets/female_soccer.png'
          case 'ski_men':
          case 'ski_women':
            return 'images/predictions/presets/ski.png'
          case 'figure':
            return 'images/predictions/presets/figure.png'
          case 'rugby':
            return 'images/predictions/presets/rugby.png'
          case 'volleyball':
            return 'images/predictions/presets/volleyball.png'
          case 'shogi':
            return 'images/predictions/presets/shogi.png'
          case 'softball':
            return 'images/predictions/presets/softball.png'
          case 'game':
            return 'images/predictions/presets/A1707453640539.png'
          case 'viewership_rating':
            return 'images/predictions/presets/A1707469651385.png'
          case 'movie':
            return 'images/predictions/presets/A1707472842833.png'
          case 'n225':
          case 'exchange':
          case 'economics':
            return 'images/predictions/presets/A1707477992898.png'
          case 'fortune':
            return 'images/predictions/presets/A1707609753420.png'
          case 'f1':
            return 'images/predictions/presets/A1707611036241.png'
          case 'mahjong':
            return 'images/predictions/presets/A1707620491430.png'
          case 'horseracing':
            return 'images/predictions/presets/A1708128314985.png'
          case 'world_table_tennis':
            return 'images/predictions/presets/A1708468932245.png'
          case 'golf':
            return 'images/predictions/presets/A1709442942369.png'
          case 'tennis':
            return 'images/predictions/presets/A1709944782175.png'
          case 'sumou':
            return 'images/predictions/presets/A1709946119901.png'
          case 'table_tennis':
            return 'images/predictions/presets/A1710503174629.png'
          case 'basketball':
            return 'images/predictions/presets/A1710503708815.png'
          case 'fighting':
            return 'images/predictions/presets/A1714783064945.png'
          case 'election':
            return 'images/predictions/presets/A1715393508494.png'
          case 'olympic':
            return 'images/predictions/presets/A1721831684930.png'
          default:
            return ''
        }
      },
      async setImageUrl (imageFileName, index) {
        const imagePath = this.getDefaultImagePath(imageFileName)
        if (imagePath) {
          const imageRef = this.$fb.ref(this.$fb.storage, imagePath)
          this.predictions[index].imageUrl = await this.$fb.getDownloadURL(imageRef)
        } else {
          this.predictions[index].imageUrl = ''
        }
      },
      async ai_world_soccer () {
        const instance = axios.create({
          baseURL: "https://asia-northeast1-dice-of-god-cd95c.cloudfunctions.net",
          headers: {
            "Content-Type": "application/json"
          },
        })
        this.loading = true
        instance.post('/getPredictionsWorldSoccer', {"data": {}})
        .then((response) => {
          this.loading = false
          console.log(response)
          const content = response.data.result.output[response.data.result.output.length - 1].content[0].text
          const json = JSON.parse(content)
          this.predictions.splice(0, this.predictions.length)
          for (let index = 0; index < json.soccer_game_info.length; index++) {
            const info = json.soccer_game_info[index]
            this.predictions.push(JSON.parse(JSON.stringify(this.predictionTemplate)))
            this.predictions[index].categoryId = '30'
            this.predictions[index].predictionTitle = `【${info.league_or_tournament_name}】${info.searched_team} vs ${info.opponent_team}の試合結果は？`
            this.predictions[index].imageFile = {name: 'world_soccer'}
            this.setImageUrl(this.predictions[index].imageFile.name, 0)
            this.predictions[index].predictionBody = `${info.game_start_datetime}から${info.match_venue}で行われる【${info.league_or_tournament_name}】${info.searched_team} vs ${info.opponent_team}の試合結果はどうなるでしょうか？`
            this.predictions[index].link1 = 'https://soccer.yahoo.co.jp/ws/'
            this.predictions[index].choices[0] = `${info.searched_team}が勝つ`
            this.predictions[index].choices[1] = `${info.opponent_team}が勝つ`
            this.predictions[index].choices[2] = `引き分け`
          }
        })
        .catch((error) => {
          this.loading = false
          console.log(error)
        })
      },
      async aiVolleyball () {
        console.log('aiVolleyball start')
        const system_prompt = `
          ### 前提
          あなたは日本で大流行している未来予想ゲームの予想問題を作成するアシスタントです。
          与えられた日付に対して、その日に実際に起きる出来事のうち結果を予想する問題が作成可能な出来事の詳細をインターネットで検索してください。
          その出来事について結果がどうなるかを予想する問題を作成してください。
          また回答は選択式とし、必ずどれか1つが正解となる選択肢を提示してください。
          与えられた年月日に起きる出来事を予想するのではなく、特定の出来事が起きた結果がどうなるかを予想する問題を作成してください。
        `

        const addDay = new Date().getDay() === 0 ? 1 : 8 - new Date().getDay()
        const fromDate = new Date(new Date().setDate(new Date().getDate() + addDay + 5)).toLocaleDateString('ja-JP')
        const toDate = new Date(new Date().setDate(new Date().getDate() + addDay + 6)).toLocaleDateString('ja-JP')
        const prediction = `
          ### 質問
          ${fromDate}、または${toDate}に日本で行われるバレーボールの大同生命SVリーグの試合結果について異なる試合の予想問題をできるだけたくさん作成してください。
          試合開始時間を見つけるのが難しいと思いますが、試合の情報と一緒に掲載されている目立つ時間を試合開始時間としてください。
          テンプレートに従い、試合開始時間と対戦するチームの名称を埋めて予想問題を作成してください。
          ### 出力形式
          JSON形式
          ### テンプレート
          [
            {
              "prediction_title": "【SVリーグ】〇〇vs△△の試合結果は？",
              "prediction_body": "M月D日(ddd) HH:mmから行われるSVリーグ：〇〇vs△△の試合結果はどうなるでしょうか？",
              "choices": [
                {"no": 1, "choice": "〇〇の勝ち"},
                {"no": 2, "choice": "△△の勝ち"}
              ]
            },
            ・・・
            {
              "prediction_title": "【SVリーグ】□□vs☆☆の試合結果は？",
              "prediction_body": "M月D日(ddd) HH:mmから行われるSVリーグ：□□vs☆☆の試合結果はどうなるでしょうか？",
              "choices": [
                {"no": 1, "choice": "□□の勝ち"},
                {"no": 2, "choice": "☆☆の勝ち"}
              ]
            }
          ]
        `
        const payload = {
          messages: [
            { role: "system", content: system_prompt },
            { role: "user", content: JSON.stringify(prediction) },
          ],
          model: "sonar",
          web_search_options: {
            search_context_size: "medium"
          }
        }
        console.log(payload)
        const instance = axios.create({
          baseURL: "https://api.perplexity.ai",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${process.env.VUE_APP_PPLX_API_KEY}`
          },
        })
        this.loading = true
        instance.post('/chat/completions', payload)
        .then((response) => {
          this.loading = false
          console.log(response)
          const content = response.data.choices[0].message.content
          const fromIndex = content.indexOf('[')
          const toIndex = content.lastIndexOf(']') + 1
          const jsonList = JSON.parse(content.substring(fromIndex, toIndex))
          this.predictions.splice(0, this.predictions.length)
          for (let index = 0; index < jsonList.length; index++) {
            const json = jsonList[index]
            this.predictions.push(JSON.parse(JSON.stringify(this.predictionTemplate)))
            this.predictions[index].categoryId = '40'
            this.predictions[index].predictionTitle = json.prediction_title
            this.predictions[index].imageFile = {name: 'volleyball'}
            this.setImageUrl(this.predictions[index].imageFile.name, 0)
            this.predictions[index].predictionBody = json.prediction_body
            this.predictions[index].link1 = 'https://www.svleague.jp/'
            for (let index2 = 0; index2 < json.choices.length; index2++) {
              const choice = json.choices[index2]
              this.predictions[index].choices[index2] = choice.choice          
            }
          }
        })
        .catch((error) => {
          this.loading = false
          console.log(error)
        })
      }
    },
    created () {
      moment.locale('ja')
      this.clear()
    }
  }
</script>